// Prevent redeclaration if this script is loaded more than once (e.g. hot reload / app scripts)
if (!customElements.get('mini-cart')) {
  class MiniCart extends HTMLElement {
    constructor() {
      super();
    }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id) && parsedState.sections && parsedState.sections[section.id]) {
        try {
          document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        } catch (error) {
          console.error('Error rendering section:', section.id, error);
        }
      }
    }));

    this.open();
  }

    getSectionsToRender() {
      return [
        {
          id: 'mini-cart',
          section: 'mini-cart',
          selector: '.shopify-section'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'mobile-cart-icon-bubble',
          section: 'mobile-cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector(selector);
      return el ? el.innerHTML : '';
    }

  setActiveElement(element) {
    this.activeElement = element;
  }
  }

  customElements.define('mini-cart', MiniCart);
}
